module.exports = __webpack_public_path__ + "img/jerk_sandwich_chicken.15e96413.jpg";